var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{staticClass:"auth-submit-button",attrs:{"block":_vm.block,"size":_vm.size,"loading":_vm.loading,"disabled":_vm.disabled,"type":_vm.type,"html-type":_vm.htmlType}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.loading ? _vm.loadingText : _vm.defaultText)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }